import React from "react";
import { Field, ErrorMessage } from "formik";

const TextareaField = ({
  label,
  name,
  placeholder,
  handleChange,
  onBlur,
  value,
  required,
  className,
  disabled,
}) => {
  return (
    <div>
      <div className="grid">
      <label className="font-semibold"
         htmlFor={name}>
          {label}
          {required && <span className="text-[red]"> *</span>}{" "}
        </label>
        <input
          as="textarea" // Use 'as' prop to specify the element type
          className={`user-fleids-area ${className}`}
          id={name}
          name={name}
          placeholder={placeholder}
          onChange={handleChange}
          onBlur={onBlur} // Add onBlur handler to mark the field as touched
          autoComplete="new-password"
          value={value}
          disabled={disabled}
        />
      </div>

      {/* <ErrorMessage name={name} component="div" className="error" /> */}
    </div>
  );
};

export default TextareaField;
